import React, { useState, useEffect } from "react";
import { baseUrl } from "../../axiosStrapi";
import axiosStrapiInstance from "../../axiosStrapi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaArrowRight } from "react-icons/fa6";
import BlogContainer from "../custom/BlogContainer";
import CustomButton from "../custom/CustomButton";
import rightArrowImg from "../../assets/rightarrow.png";
import leftArrowImg from "../../assets/leftarrow.png";
import Loader from "../custom/Loader";
import axios from "axios";
import qs from "qs";
const HomeBlogs = () => {
  const [loading, setLoading] = useState(false);
  const [blog, setBlogs] = useState([]);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: (
      <div>
        <img className="custom-arrow" src={rightArrowImg} alt="Next" />
      </div>
    ),
    prevArrow: (
      <div>
        <img className="custom-arrow" src={leftArrowImg} alt="Previous" />
      </div>
    ),
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosStrapiInstance.get(
          "/api/blogs?filters[Type][$eq]=Blogs&populate[headerImages][populate]=*&sort[createdAt]=desc"
        );
        const data = response?.data?.data?.slice(0, 3) || [];
        setBlogs(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  async function sendEnquiry() {
    const unid = Math.floor(Math.random() * 888888) + 111111;
    const Branch = "punjabi bagh";

    const params = {
      user_type: 2,
      name: "Ayush" || "",
      mobile_no: "8470030010" || "",
      child_name: "vibhav" || "",
      email: "akrrajput1@gmail.com" || "",
      class_section_id: "",
      address: "",
      purpose: "New Admission",
      description: "my query is regarding admission fees" || "",
      other_details: JSON.stringify({ brn: Branch || "" }),
      type: 1,
      source_type: 48,
      gender: "male",
    };

    const branchMap = {
      "punjabi bagh": "mppb",
      deepali: "mpd",
      pitampura: "mpppit",
      "ashok vihar": "mpav",
      "dwarka sec 17": "mpdw17",
      "rohini sec 5": "mproh5",
      "noida sec 31": "mpnoida31",
      indirapuram: "mpind",
      "vivek vihar": "mpviv",
      "gurgaon sec 57": "mpggnp",
      "gurgaon sec 40": "mpgg40",
      "gurgaon sec 5": "mpgg5",
      "gurgaon sec 9a": "mpgg9a",
      "gurgaon sec 49": "mpgg49",
    };

    const brn = (Branch || "").toLowerCase();
    let domain = branchMap[brn] || "mppb";

    const url = `https://${domain}.udtweb.com/api/Enquiry/add.json`;

    try {
      const response = await axios.post(url, qs.stringify(params), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          "User-Agent": "Mozilla/5.0",
          "X-Apple-Tz": "0",
          "X-Apple-Store-Front": "143444,12",
          Accept:
            "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
          "Accept-Encoding": "gzip, deflate",
          "Accept-Language": "en-US,en;q=0.5",
          "Cache-Control": "no-cache",
          "X-MicrosoftAjax": "Delta=true",
        },
      });
      return response.data;
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      throw error;
    }
  }

  return (
    <div className="text-center">
      <div className="w-[90%] sm:w-[60%] mx-auto text-[32px] sm:mt-0 mt-[70px] sm:text-[2.8rem]">
        <p className={"text-[#D31C4F] font-semibold"}>
          Unlock invaluable wisdom personalized for{" "}
          <span className="font-Lato text-[#7F7D7D] ">
            you in our top-notch Blogs
          </span>
        </p>
      </div>
      {
        loading ? <Loader />:
        <>
          <div className="px-[7%] mt-[60px] sm:hidden block">
            <Slider {...settings} className="sm:px-0 px-2">
              {blog?.map((post, index) => (
                <div>
                  <div
                    key={index}
                    style={{
                      borderRadius: "10px",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      textAlign: "left",
                    }}
                    className="shadow-md mb-4 mr-3 rounded-[10px]"
                  >
                    <img
                      src={post?.headerImages?.mobileCardImage ? `${post?.headerImages.mobileCardImage.url}`: `${post?.headerImages?.desktopHeaderImage?.url}`}
                      alt={post.title}
                      className="rounded-tl-[10px] rounded-tr-[10px]"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                    <div style={{ padding: "15px" }}>
                      <h3
                        className="font-bold text-left"
                        style={{
                          fontSize: "18px",
                          color: "#333",
                          margin: "0 0 10px 0",
                        }}
                      >
                        {post.title}
                      </h3>
                      <p
                        className="font-xl text-left"
                        style={{
                          color: "#666",
                          margin: "0 0 15px 0",
                        }}
                      >
                        {`${post.description?.substr(0, 90)}...`}
                      </p>
                      <a
                        className="text-xl"
                        href={`/blog/${post?.title?.replaceAll(" ","-")}/${post?.documentId}`}
                        style={{
                          color: "#D31C4F",
                          textDecoration: "none",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                      >
                        Read More <FaArrowRight className="inline" />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
              {blog?.length < 2 &&
                blog?.map((post, index) => (
                  <div>
                    <div
                      key={index}
                      style={{
                        borderRadius: "10px",
                        overflow: "hidden",
                        backgroundColor: "#fff",
                        textAlign: "left",
                      }}
                      className="shadow-md mb-4 mr-3  rounded-[10px]"
                    >
                      <img
                        src={`${post?.headerImages?.desktopHeaderImage?.url}`}
                        alt={post.title}
                        className="rounded-tl-[10px] rounded-tr-[10px]"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                        }}
                      />
                      <div style={{ padding: "15px" }}>
                        <h3
                          className="font-bold text-left"
                          style={{
                            fontSize: "18px",
                            color: "#333",
                            margin: "0 0 10px 0",
                          }}
                        >
                          {post.title}
                        </h3>
                        <p
                          className="font-xl text-left"
                          style={{
                            color: "#666",
                            margin: "0 0 15px 0",
                          }}
                        >
                          {`${post.description?.substr(0, 90)}...`}
                        </p>
                        <a
                          className="text-xl"
                          href={`/blog/${post?.documentId}`}
                          style={{
                            color: "#D31C4F",
                            textDecoration: "none",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        >
                          Read More <FaArrowRight className="inline" />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
            </Slider>
            <CustomButton
              text={"See More"}
              marginY={"25px"}
              marginX={"auto"}
              handleClick={() => window.open("/blogs", "_self")}
            />
          </div>
          <div className="hidden w-full sm:block px-[6%] pt-[2.5rem]">
            <BlogContainer data={blog} />
            <CustomButton
              text={"See More"}
              marginY={"25px"}
              marginX={"auto"}
              handleClick={() => window.open("/blogs", "_self")}
              //handleClick={sendEnquiry}
            />
          </div>
        </>
      }
    </div>
  );
};

export default HomeBlogs;
